var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{class:{'mobile': _vm.isMobile}},[_c('div',{staticClass:"menu"},[_c('privacy-policy-link',{staticClass:"support-link text-decoration-none"})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }